import React, { Component } from "react";
import { Translation } from "react-i18next";
import { defaultDementions, helpContentAlignTypes, helpContentType, helpTitleTypes, helpViewType } from "./Const";
import 'react-quill/dist/quill.snow.css'
import { appConfig } from "App";

class HelpContent extends Component {
  constructor(props) {
    super();
    this.state = {};
  }

  componentDidMount() {}

  populateHelpData = (text ="") => {
    let markup = {
        inline: ["bo", "un", "it", "ln", "img","vdo", "f1", "f2", "f3"],
        block: ["pr", "st", "ss", "t1", "t2", "t3","div"],
      };
  
      markup.inline.map((v) => {
        let startTag;
        let endTag;
        let partIdPatt;
  
        switch (v) {
          case "ln":
            partIdPatt = /(\#ln([^\[\]](?!(\#\/ln)))*)\[([^\[\]]*)\]/g; //change "ln" inside the pattern accordingly if tag name changed
            let lnTag = "";
            let href = "";
  
            if (partIdPatt.test(text)) {
              let partIdMatches = text.match(partIdPatt);
  
              for (let mtch in partIdMatches) {
                if (partIdMatches[mtch]) {
                  lnTag = partIdMatches[mtch];
                  href = lnTag.slice(4, (lnTag.length - 1));
                }
                text = text.replace(lnTag ? lnTag : ("#" + v), "<a href=" + (href ? href : "javascript:void(0)") + " class=\"" + v + "\">");
              }
  
            }
  
            text = text.replace(("#" + v), "<a href=\"javascript:void(0)\" class=\"" + v + "\">"); //if anchor tag listed without href
  
            endTag = new RegExp("#/" + v, "g");
            text = text.replace(endTag, "</a>");
            break;
  
          case "img": //image
            partIdPatt = /(\#img([^\[\]](?!(\#\/img)))*)\[([^\[\]]*)\]/g; //change "img" inside the pattern accordingly if tag name changed
            let imgTag = "";
            let prop = [];
            let src = "";
            let altTxt = "ML Admin Image";
            let cls = "";
            let id = "";
  
            if (partIdPatt.test(text)) {
              let partIdMatches = text.match(partIdPatt);
  
              for (let mtch in partIdMatches) {
                if (partIdMatches[mtch]) {
                  imgTag = partIdMatches[mtch];
                  prop = imgTag.slice(5, (imgTag.length - 1)).split(",");
                  src = prop[0];
                  if (prop[1]) { altTxt = prop[1] }
                  if (prop[2]) { cls = prop[2] }
                  if (prop[3]) { id = prop[3]; }
                }
                
                // text = text.replace(imgTag ? imgTag : ("#" + v), "<img crossOrigin='anonymous' src=\"" + src + "\" id=\"" + id + "\" alt=\"" + altTxt + "\" class=\"" + (cls ? (cls + " ") : "") + v + "\" >");
                text = text.replace(imgTag ? imgTag : ("#" + v), "<img src=\"" + src + "\" id=\"" + id + "\" alt=\"" + altTxt + "\" class=\"" + (cls ? (cls + " ") : "") + v + "\" width='100%'>");
              }
            }
            
            endTag = new RegExp("#/" + v, "g");
            text = text.replace(endTag, "");
  
            break;
          
            case "vdo": //video
              partIdPatt = /(\#vdo([^\[\]](?!(\#\/vdo)))*)\[([^\[\]]*)\]/g;
              let videoTag = "";
              let videoProp = [];
              let videoSrc = "";

              if (partIdPatt.test(text)) {
                let partIdMatches = text.match(partIdPatt);
    
                for (let mtch in partIdMatches) {
                  if (partIdMatches[mtch]) {
                    videoTag = partIdMatches[mtch];
                    videoProp = videoTag.slice(5, (videoTag.length - 1)).split(",");
                    videoSrc = videoProp[0];
                  }

                  // text = text.replace(iframeTag ? iframeTag : ("#" + v), "<iframe src=\"" + videoSrc + "\" style='border:none;' width='100%' height='250' >");
                  text = text.replace(videoTag ? videoTag : ("#" + v), "<video width='320' height='240' controls controlsList='nodownload' disablePictureInPicture> <source type='video/mp4' src=\"" + videoSrc + "\" />");
                
                }
              }

              endTag = new RegExp("#/" + v, "g");
              text = text.replace(endTag, "Your browser does not support the video tag. </video>");

              break;
  
          default:
            startTag = new RegExp("#" + v, "g");
            text = text.replace(startTag, "<span class=\"" + v + "\">");
  
            endTag = new RegExp("#/" + v, "g");
            text = text.replace(endTag, "</span>");
            break;
        }
      });
  
  
      markup.block.map((v) => {
        let startTag;
        let endTag;
        switch (v) {
          case "st":
            startTag = new RegExp("#" + v, "g");
            text = text.replace(startTag, "<ul class=\"" + v + "\">");
  
            endTag = new RegExp("#/" + v, "g");
            text = text.replace(endTag, "</ul>");
  
            break;
          case "ss":
            startTag = new RegExp("#" + v, "g");
            text = text.replace(startTag, "<li class=\"" + v + "\">");
  
            endTag = new RegExp("#/" + v, "g");
            text = text.replace(endTag, "</li>");
            break;
  
          default:
            startTag = new RegExp("#" + v, "g");
            text = text.replace(startTag, "<div class=\"" + v + "\">");
  
            endTag = new RegExp("#/" + v, "g");
            text = text.replace(endTag, "</div>");
            break;
        }
  
      });
  
      return (
          <div dangerouslySetInnerHTML={{__html: text}}></div>
      ); 
  };

  renderHelpContent = (content) => {
    const { config } = this.props;
    let helpData = content.data;
    switch (content.type) {
      case helpContentType.TITLE:
        let hClass = helpTitleTypes.filter(v=> v.id === helpData.variation)[0].label || "H1"
        return(
          <>
            <span class={hClass}>{helpData.text || ""}</span>
          </>
        );
      case helpContentType.PARAGRAPH:
        return(
          <>
            <div class="help-paragraph ql-editor" dangerouslySetInnerHTML={{__html : (helpData.text || "")}}></div>
          </>
        );
      case helpContentType.IMAGE:
        let hImgAlign = helpContentAlignTypes.filter(v=> v.id === helpData.allign)[0].label || "left"

        if(!helpData?.src){  
          return (<></>); 
        }

        return(
          <>
            <img 
              alt="ML Admin help image" 
              class={`help-image ${hImgAlign}`} 
              src={helpData?.src || ""}  
              width={helpData?.width || defaultDementions.WIDTH ||'100%'} 
              height={helpData?.height || defaultDementions.HEIGHT || 'auto'}
            />
          </>
        );
      case helpContentType.VIDEO:
        if((config && config.type === helpViewType.TOOLTIP) || !helpData?.src){  
          return (<></>); 
        }

        let hVdoAlign = helpContentAlignTypes.filter(v=> v.id === helpData.allign)[0].label || "left"
        return(
          <>
            <video width={helpData?.width || defaultDementions.WIDTH} height={helpData?.height || defaultDementions.HEIGHT} controls controlsList="nodownload" disablePictureInPicture onContextMenu={(e)=> e.preventDefault()} class={`help-video ${hVdoAlign}`}> 
              <source type='video/mp4' src={helpData?.src || ""} />
              <source type='video/ogg' src={helpData?.src || ""} />
              <source type='video/webm' src={helpData?.src || ""} />
              {'Your browser does not support the video tag.'}
            </video>
          </>
        );

      case helpContentType.PRIVATE_VIDEO:

        if((config && config.type === helpViewType.TOOLTIP) || !helpData?.key){  
          return (<></>); 
        }

        let privateVdoAlign = helpContentAlignTypes.filter(v=> v.id === helpData.allign)[0].label || "left";

        let url = `${appConfig.CENTRAL_API}/getHelpVideoLink/${Buffer.from(helpData.key).toString('base64')}/${encodeURIComponent(localStorage.getItem("FBIdToken").split("Bearer ")[1])}`
        
        return(
          <> 
            <video onContextMenu={(e)=> e.preventDefault()} width={helpData?.width || defaultDementions.WIDTH} height={helpData?.height || defaultDementions.HEIGHT} controls controlsList="nodownload" disablePictureInPicture class={`help-video ${privateVdoAlign}`}> 
              <source type='video/mp4' src={url || ""} />
              <source type='video/ogg' src={url || ""} />
              <source type='video/webm' src={url || ""} />
              {'Your browser does not support the video tag.'}
            </video>         
          </>
        );

      case helpContentType.EMBEDDED:
        if((config && config.type === helpViewType.TOOLTIP) || !helpData?.src){  
          return (<></>); 
        }

       let wrapperEle = document.createElement("div");
       
       wrapperEle.innerHTML= helpData?.src
       
       let contentEle = wrapperEle.querySelector('iframe');
       if(contentEle){
         contentEle.width = helpData?.width || defaultDementions.WIDTH
         contentEle.height = helpData?.height || defaultDementions.HEIGHT
       }

        return(
          <>
            <div dangerouslySetInnerHTML={{__html: contentEle ? contentEle.outerHTML : ""}}></div>

            {/* <iframe 
              src={helpData?.src || ""} 
              width={helpData?.width || defaultDementions.WIDTH} 
              height={helpData?.height || defaultDementions.HEIGHT}
              title="ML Admin embedded content"> </iframe> */}
          </>
        );
    
      default:
        break;
    }
  }

  render() {
    const { classes, selectedHelp } = this.props;

    return (
      <Translation key={Math.random()}>
        {(t, { i18n }) => (
          <>
            {selectedHelp?.content?.length > 0 && selectedHelp.content.map((hContent)=>{
                return this.renderHelpContent(hContent);
                  }) 
            }
            {/* {selectedHelp?.content &&  this.populateHelpData(selectedHelp.content) } */}
          </>
        )}
      </Translation>
    );
  }
}



export default HelpContent;
